<template>
	<div>
		<div class="p-d-flex p-jc-center">
			<h2 class="titleFont p-text-bold">Step 4: Verify and Pay</h2>
		</div>

		<Transition name="fade" mode="out-in">
			<div v-if="!proceedBtnLoading" key="summary">
				<div class="p-d-flex p-flex-column column-line-spacing">
					<h1 class="p-mt-0 p-mb-2 p-primary-color">
						${{
							store.S1FormData.totalOfAllStudents != undefined
								? store.S1FormData.totalOfAllStudents.toFixed(2)
								: "0.00"
						}}
						CAD
					</h1>
					<div v-for="entry in store.S1StudentInfoData" :key="entry.firstName">
						<h3>
							{{ entry.firstName }} {{ entry.lastName }} - ${{
								entry.studentTotalAmount.toFixed(2)
							}}
						</h3>
						<p v-if="entry.selectedMealProgram.value == 'SMP'">
							<span class="p-text-bold">Meal Semester Chosen:</span>
							{{ entry.mealSemester }}
						</p>
						<p v-if="entry.selectedMealProgram.value != 'MNA'">
							<span class="p-text-bold">Meal Program Chosen:</span>
							{{ entry.selectedMealProgram.label }}
							<span v-if="entry.selectedMealProgram.key == 'MLF'"
								>- ${{ entry.studentTotalAmount.toFixed(2) }}</span
							>
						</p>
						<p v-if="entry.selectedBusService.value != 'BNA'">
							<span class="p-text-bold">Bus Semester Chosen:</span>
							{{ entry.busSemester }}
						</p>
						<p v-if="entry.selectedBusService.value != 'BNA'">
							<span class="p-text-bold">Bus Program Chosen:</span>
							{{ entry.selectedBusService.label }}
						</p>
					</div>
				</div>

				<div
					class="p-d-flex p-flex-column p-flex-md-row p-ai-sm-center p-ai-md-start p-jc-evenly column-line-spacing"
				>
					<div class="p-d-flex p-flex-column">
						<h4 class="p-mb-2" style="text-decoration: underline">
							Parent Information
						</h4>
						<span>{{ store.S2FormData.companyName }}</span>
						<div class="p-text-bold">
							{{ store.S2FormData.firstName }} {{ store.S2FormData.lastName }}
						</div>
						<div>
							{{ store.S2FormData.address }}, {{ store.S2FormData.address2 }}
						</div>
						<div>
							{{ store.S2FormData.city }}, {{ store.S2FormData.region }},
							{{ store.S2FormData.postalCode }}
						</div>

						<div>{{ store.S2FormData.phoneNumber }}</div>
						<div>{{ store.S2FormData.email }}</div>
					</div>

					<div class="p-d-flex p-flex-column">
						<h4 class="p-mb-2" style="text-decoration: underline">
							Payment Information
						</h4>

						<span>Card Number: {{ maskedCardNumber() }}</span>

						<span>
							Expiry Date: {{ store.S3FormData.expiryMonth }}/{{
								store.S3FormData.expiryYear
							}}
						</span>

						<span>Cardholder Name: {{ store.S3FormData.cardHolder }}</span>
					</div>
				</div>

				<div class="p-grid p-formgrid p-mt-3 p-jc-center">
					<div class="p-col-12 p-sm-8 p-md-6 p-lg-6 p-xl-5 p-ai-center">
						<div
							class="p-d-flex p-flex-column-reverse p-flex-sm-row p-ai-center p-jc-evenly"
						>
							<div class="p-mb-3">
								<Button
									label="Back"
									icon="pi pi-angle-left"
									class="p-button-secondary"
									style="min-width: 120px; max-width: 120px"
									:disabled="proceedBtnLoading ? 'disabled' : null"
									@click="prevStep"
								/>
							</div>

							<div class="p-mb-3">
								<Button
									label="Proceed to Pay"
									icon="pi pi-check"
									iconPos="right"
									style="min-width: 180px; max-width: 180px"
									:loading="proceedBtnLoading"
									@click="nextStep"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div v-else key="processing">
				<i
					class="pi pi-spin pi-spinner p-primary-color"
					style="font-size: 5rem"
				></i>
				<h2 class="titleFont p-text-center p-pt-2 p-text-bold">
					Processing your payment...
				</h2>
			</div>
		</Transition>
	</div>
</template>

<script>
import axios from "axios";
import moment from "moment";

import { useFormDataStore } from "../../store/formData.js";

export default {
	name: "S4Form",
	data() {
		return {
			proceedBtnLoading: false,
		};
	},
	setup() {
		const store = useFormDataStore();

		return {
			store,
		};
	},
	methods: {
		async submitForm() {
			let token = await this.generateRecaptchaToken();

			let studentData = [];
			Object.values(this.store.S1StudentInfoData).forEach((student) => {
				studentData.push({
					firstName: student.firstName,
					lastName: student.lastName,
					studentGrade: student.selectedGrade.label,
					// selectedMealProgram: student.selectedMealProgram.name, //used for mealOnly
					selectedMealProgram: student.selectedMealProgram.label,

					selectedMealSemester: student.selectedMealSemester
						? student.selectedMealSemester.label
						: null,
					// TODO: uncomment the below code IF luther wants meals and buses both!

					mealTotalAmount: student.mealTotalAmount,
					busTotalAmount: student.busTotalAmount,
					selectedBusSemester: student.busSemester,
					selectedBusService: student.selectedBusService.label,
					fobAmount:
						student.selectedMealProgram.value == "MLF"
							? student.selectedMealProgram.price
							: 0,
					studentTotalAmount: student.studentTotalAmount,
				});
			});

			// console.log({
			//   formData: {
			//     ...this.store.S1StudentInfoData,
			//     ...this.store.S1FormData,
			//     ...this.store.S2FormData,
			//     ...this.store.S3FormData,
			//     queryString: window.location.search,
			//     dt: moment(new Date(Date.now())).format(),
			//     sandbox: this.store.loadParamsFn.testMode
			// 			? this.store.loadParamsFn.testMode
			// 			: false,
			//     campaignId: this.store.campaignId,
			//     token: token,
			//   },
			//   studentData
			// });

			await axios
				.post(process.env.VUE_APP_PROCESS_API, {
					...this.store.S1FormData,
					...this.store.S2FormData,
					...this.store.S3FormData,
					queryString: window.location.search,
					amount: this.store.S1FormData.totalOfAllStudents,
					dt: moment(new Date(Date.now())).format(),
					sandbox: this.store.loadParamsFn.testMode
						? this.store.loadParamsFn.testMode
						: false,
					campaignId: this.store.campaignId,
					token: token,
					studentData,
				})
				.then((response) => {
					// console.log(response.data);
					this.store.setFormSubmissionData({
						status: response.data.status,
						merchantId: response.data.merchantId,
						errorMessage:
							response.data.message != undefined ? response.data.message : null,
					});
				});
		},
		async nextStep() {
			this.proceedBtnLoading = true;

			await this.submitForm().then(() => {
				this.proceedBtnLoading = false;

				this.$emit("formSubmitted");
			});
		},
		prevStep() {
			this.$emit("prevStep");
		},
		async generateRecaptchaToken() {
			let recaptchaObject = this.store.recaptchaObject;
			const gtoken = await recaptchaObject.execute("pllentyForm");

			return gtoken;
		},
		maskedCardNumber() {
			let cardNumber = this.store.S3FormData.cardNumber;

			if (cardNumber) {
				return `${"*".repeat(cardNumber.length - 4)}${cardNumber.substr(
					cardNumber.length - 4
				)}`;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.titleFont {
	font-size: 1.9rem;
}

.column-line-spacing {
	line-height: 1.4rem;
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>
